import { useIntl } from 'react-intl';
import {
  PromptSuggestionCategory,
  PromptSuggestionsChipCarousel,
} from '@rossum/components/prompt-suggestions-chip-carousel/PromptSuggestionsChipCarousel';
import {
  IconBuildingBank,
  IconBuildingStore,
  IconClipboardText,
  IconCurrencyDollar,
  IconMapPin,
  IconPackage,
  IconRuler2,
  IconTag,
} from '@rossum/ui/icons/tabler';
import { SvgIcon } from '@rossum/ui/material';
import { promptSuggestionsCategories } from '../prompt_suggestions';

type CategoryIconKey = (typeof promptSuggestionsCategories)[number]['icon'];

const categoryIconMap: Record<CategoryIconKey, React.ReactElement> = {
  buildingStore: (
    <SvgIcon fontSize="large">
      <IconBuildingStore />
    </SvgIcon>
  ),
  clipboardText: (
    <SvgIcon fontSize="large">
      <IconClipboardText />
    </SvgIcon>
  ),
  tag: (
    <SvgIcon fontSize="large">
      <IconTag />
    </SvgIcon>
  ),
  buildingBank: (
    <SvgIcon fontSize="large">
      <IconBuildingBank />
    </SvgIcon>
  ),
  ruler2: (
    <SvgIcon fontSize="large">
      <IconRuler2 />
    </SvgIcon>
  ),
  mapPin: (
    <SvgIcon fontSize="large">
      <IconMapPin />
    </SvgIcon>
  ),
  package: (
    <SvgIcon fontSize="large">
      <IconPackage />
    </SvgIcon>
  ),
  currencyDollar: (
    <SvgIcon fontSize="large">
      <IconCurrencyDollar />
    </SvgIcon>
  ),
};

type LookupPromptSuggestionsProps = {
  onPromptSelect: (prompt: string) => void;
  disabled?: boolean;
  className?: string;
};

export const PromptSuggestions = ({
  onPromptSelect,
  disabled,
  className,
}: LookupPromptSuggestionsProps) => {
  const intl = useIntl();

  const categories: PromptSuggestionCategory<CategoryIconKey>[] =
    promptSuggestionsCategories.map(category => ({
      ...category,
      label: intl.formatMessage({
        id: `features.queueSettings.fields.lookup.promptSuggestions.categories.${category.icon}`,
      }),
    }));

  return (
    <PromptSuggestionsChipCarousel
      categories={categories}
      iconMap={categoryIconMap}
      onPromptSelect={onPromptSelect}
      disabled={disabled}
      className={className}
    />
  );
};
